module.exports = {"name":"hbbtvhtml5","type":"adapter","tech":"js","author":"Jesus Lopez","version":"6.1.0","built":"2018-03-15","repo":"https://bitbucket.org/npaw/hbbtvhtml5-adapter-js","libVersion":"6.1.13","features":{"buffer":"monitor","seek":"monitor","getters":["getPlayhead","getDuration","getResource"]},"ads":[]}


//////////////////
// WEBPACK FOOTER
// ./manifest.json
// module id = 27
// module chunks = 0